// extracted by mini-css-extract-plugin
export default {"smallWidth":"CustomerReport_smallWidth__4iI34","mediumWidth":"CustomerReport_mediumWidth__yphAk","largeWidth":"CustomerReport_largeWidth__cpoDN"};